import Animated, { FlipInEasyY } from 'react-native-reanimated';
import Loading from '../../../Loading/Loading';
import { AnswerSelectPresentationProps } from '../config';
import { FC } from 'react';
import { SingleSelectChoice } from './PresentDefault/SingleSelectChoice';
import { View } from 'react-native';
import { observer } from 'mobx-react';
import { useStores } from '../../../../hooks/useStores';

interface ChoiceObserverProps {
  id: string;
  label: string;
  caption?: string;
  onPress: () => void;
  index?: number;
}
// Mirrors the pattern in PresentDefault — inlining mobx state into FlatList's
// renderItem breaks observability, so a tiny observer wrapper holds it.
const ChooseServiceChoiceObserver = observer(({
  id,
  label,
  caption,
  onPress,
  index = 0,
}: ChoiceObserverProps) => {
  const { treeNav } = useStores();
  return (
    <Animated.View
      entering={FlipInEasyY.duration((200 + index * 50))}
    >
      <SingleSelectChoice
        key={id}
        label={label}
        caption={caption}
        selected={!!treeNav.choices.pending?.answers.some(a => a.id === id)}
        onPress={onPress}
      />
    </Animated.View>
  );
});

const _PresentChooseService: FC<AnswerSelectPresentationProps> = ({
  answers,
  onPress,
  loading,
}) => {
  if (loading) {
    return <Loading />;
  }
  // a handful of services: rendered as plain rows, not a list of their own
  // (a FlatList inside the frame's ScrollView triggers the nested-list warning)
  return (
    <View>
      {(answers || []).map((item, index) => {
        // The dynq attaches WPO's shortDescription as meta key 'description'.
        // Surface it as a caption so users understand what each service is —
        // especially important now that we relabel some services
        // (e.g. "General Assistance" → "I don't know which service to choose").
        const caption = item.meta?.find(m => m.key === 'description')?.value || undefined;
        return (
          <ChooseServiceChoiceObserver
            key={item._id}
            id={item._id}
            label={item?.wording || ''}
            caption={caption}
            onPress={() => onPress(item)}
            index={index}
          />
        );
      })}
    </View>
  );
};

export const PresentChooseService = observer(_PresentChooseService);
